// missions
export const GET_MISSIONS = 'GET_MISSIONS';

// contributions
export const CONTRIBUTION_APPROVE = 'CONTRIBUTION_APPROVE';
export const DELETE_CONTRIBUTION = 'DELETE_CONTRIBUTION';
export const EDIT_CONTRIBUTION_TIME = 'EDIT_CONTRIBUTION_TIME';
export const UPDATE_CONTRIBUTION_END_DATE = 'UPDATE_CONTRIBUTION_END_DATE';
export const UPDATE_CONTRIBUTION_STATE_WHEN_MASTER =
  'UPDATE_CONTRIBUTION_STATE_WHEN_MASTER';

// react-admin
export const CLEAR_FIELDS = 'CLEAR_FIELDS';



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js